// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-4bd59bb1] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
#app-settings[data-v-4bd59bb1] {
  margin-top: auto;
  padding: 3px;
}
#app-settings__header[data-v-4bd59bb1] {
  box-sizing: border-box;
  margin: 0 3px 3px 3px;
}
#app-settings__header .settings-button[data-v-4bd59bb1] {
  display: flex;
  flex: 1 1 0;
  height: 44px;
  width: 100%;
  padding: 0;
  margin: 0;
  background-color: var(--color-main-background);
  box-shadow: none;
  border: 0;
  border-radius: var(--border-radius-pill);
  text-align: left;
  font-weight: normal;
  font-size: 100%;
  color: var(--color-main-text);
  padding-right: 14px;
  line-height: 44px;
}
#app-settings__header .settings-button[data-v-4bd59bb1]:hover, #app-settings__header .settings-button[data-v-4bd59bb1]:focus {
  background-color: var(--color-background-hover);
}
#app-settings__header .settings-button__icon[data-v-4bd59bb1] {
  width: 44px;
  height: 44px;
  min-width: 44px;
}
#app-settings__header .settings-button__label[data-v-4bd59bb1] {
  overflow: hidden;
  max-width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
}
#app-settings__content[data-v-4bd59bb1] {
  display: block;
  padding: 10px;
  /* prevent scrolled contents from stopping too early */
  margin-bottom: -3px;
  /* restrict height of settings and make scrollable */
  max-height: 300px;
  overflow-y: auto;
  box-sizing: border-box;
}
.slide-up-leave-active[data-v-4bd59bb1],
.slide-up-enter-active[data-v-4bd59bb1] {
  transition-duration: var(--animation-slow);
  transition-property: max-height, padding;
  overflow-y: hidden !important;
}
.slide-up-enter[data-v-4bd59bb1],
.slide-up-leave-to[data-v-4bd59bb1] {
  max-height: 0 !important;
  padding: 0 10px !important;
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcAppNavigationSettings-BCkvRAy8.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;;;;;;;;;;;;;;;;;;;;EAoBE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,WAAW;EACX,UAAU;EACV,SAAS;EACT,8CAA8C;EAC9C,gBAAgB;EAChB,SAAS;EACT,wCAAwC;EACxC,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,+CAA+C;AACjD;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,aAAa;EACb,sDAAsD;EACtD,mBAAmB;EACnB,oDAAoD;EACpD,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;;EAEE,0CAA0C;EAC1C,wCAAwC;EACxC,6BAA6B;AAC/B;AACA;;EAEE,wBAAwB;EACxB,0BAA0B;AAC5B","sourcesContent":["@charset \"UTF-8\";\n/**\n * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @author John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @license GNU AGPL version 3 or any later version\n *\n * This program is free software: you can redistribute it and/or modify\n * it under the terms of the GNU Affero General Public License as\n * published by the Free Software Foundation, either version 3 of the\n * License, or (at your option) any later version.\n *\n * This program is distributed in the hope that it will be useful,\n * but WITHOUT ANY WARRANTY; without even the implied warranty of\n * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the\n * GNU Affero General Public License for more details.\n *\n * You should have received a copy of the GNU Affero General Public License\n * along with this program. If not, see <http://www.gnu.org/licenses/>.\n *\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-4bd59bb1] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n#app-settings[data-v-4bd59bb1] {\n  margin-top: auto;\n  padding: 3px;\n}\n#app-settings__header[data-v-4bd59bb1] {\n  box-sizing: border-box;\n  margin: 0 3px 3px 3px;\n}\n#app-settings__header .settings-button[data-v-4bd59bb1] {\n  display: flex;\n  flex: 1 1 0;\n  height: 44px;\n  width: 100%;\n  padding: 0;\n  margin: 0;\n  background-color: var(--color-main-background);\n  box-shadow: none;\n  border: 0;\n  border-radius: var(--border-radius-pill);\n  text-align: left;\n  font-weight: normal;\n  font-size: 100%;\n  color: var(--color-main-text);\n  padding-right: 14px;\n  line-height: 44px;\n}\n#app-settings__header .settings-button[data-v-4bd59bb1]:hover, #app-settings__header .settings-button[data-v-4bd59bb1]:focus {\n  background-color: var(--color-background-hover);\n}\n#app-settings__header .settings-button__icon[data-v-4bd59bb1] {\n  width: 44px;\n  height: 44px;\n  min-width: 44px;\n}\n#app-settings__header .settings-button__label[data-v-4bd59bb1] {\n  overflow: hidden;\n  max-width: 100%;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n#app-settings__content[data-v-4bd59bb1] {\n  display: block;\n  padding: 10px;\n  /* prevent scrolled contents from stopping too early */\n  margin-bottom: -3px;\n  /* restrict height of settings and make scrollable */\n  max-height: 300px;\n  overflow-y: auto;\n  box-sizing: border-box;\n}\n.slide-up-leave-active[data-v-4bd59bb1],\n.slide-up-enter-active[data-v-4bd59bb1] {\n  transition-duration: var(--animation-slow);\n  transition-property: max-height, padding;\n  overflow-y: hidden !important;\n}\n.slide-up-enter[data-v-4bd59bb1],\n.slide-up-leave-to[data-v-4bd59bb1] {\n  max-height: 0 !important;\n  padding: 0 10px !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
